import { getISOTime } from '../getters/get-time-stamp';
import { sendPackage } from '../helpers/send-package';
import { getBufferSize } from '../config/config';
import { isEqual } from '../helpers/is-equal';

/**
* Массив событий в пакете
*/

const packageStorage = [];
const isSameAdditionalData = ({
  meta: {
    timeStamp: timeStampA,
    ...restMetaA
  },
  profile: profileA
}, {
  meta: {
    timeStamp: timeStampB,
    ...restMetaB
  },
  profile: profileB
}) => {
  return isEqual(restMetaA, restMetaB) && isEqual(profileA, profileB);
};
const joinPackage = (pkg, item) => {
  pkg?.data.push(item.data[0]);
  // Время пересборки пакета обновлено
  pkg.meta.timeStamp = getISOTime();
};
const addPackage = pkg => {
  packageStorage.push(pkg);
};
export const isStorageEmpty = () => !packageStorage.length;
export const flushStorage = (full = false) => {
  while (packageStorage.length > Number(!full)) {
    const pkg = packageStorage.shift();
    if (pkg) {
      void sendPackage(pkg).catch(error => {
        // Ввиду асинхронности данного кода, сперва выполнится весь while,
        // а только потом неудачные пакеты вернутся в хранилище
        packageStorage.unshift(pkg);
        throw error;
      });
    }
  }
};
export const pushStorage = nextItem => {
  const lastItem = packageStorage[packageStorage.length - 1];
  if (!lastItem || lastItem.data.length >= getBufferSize() || !isSameAdditionalData(lastItem, nextItem)) {
    // Хранилище пустое, добавляем пакет
    // Буфер заполнен или изменились сопровождающие данныедобавляем пакет
    addPackage(nextItem);
  } else {
    // Пакет еще можно пополнить
    joinPackage(lastItem, nextItem);
  }
  const nextLastItem = packageStorage[packageStorage.length - 1];
  if (nextLastItem && nextLastItem.data.length >= getBufferSize()) {
    // Пакет заполнился, отправляем все
    flushStorage(true);
  } else if (packageStorage.length > 1) {
    // Если есть очередь, то сразу отправляем все, что есть до последнего запроса
    flushStorage();
  }
};